module.exports = __webpack_public_path__ + "static/media/video-placeholder.f5072464.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/_molecules/MediaLibrary/assets/video-placeholder.png
// module id = 1302
// module chunks = 0